import { render, staticRenderFns } from "./VideoPicker.vue?vue&type=template&id=5a0b97a2&scoped=true&"
import script from "./VideoPicker.vue?vue&type=script&lang=js&"
export * from "./VideoPicker.vue?vue&type=script&lang=js&"
import style0 from "./VideoPicker.vue?vue&type=style&index=0&id=5a0b97a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0b97a2",
  null
  
)

export default component.exports